/**
 * Curated free-licence imagery (Unsplash). Dignified, non-exploitative — landscapes,
 * hands, learning, community, work — per the guidance in /public/images/CREDITS.md.
 * IDs are pinned (stable) and every <Figure> degrades to a brand gradient on error, so a
 * dropped CDN never shows a broken image.
 *
 * `img(id, w, h)` builds a sized, optimised Unsplash URL. Keep widths modest — these are
 * decorative, and the page should stay light.
 */
const UNSPLASH = 'https://images.unsplash.com';

export function img(id, w = 1200, h) {
  const crop = h ? `&fit=crop&h=${h}` : '&fit=max';
  return `${UNSPLASH}/${id}?auto=format&q=70&w=${w}${crop}`;
}

/** Named image tokens used across the site. One source of truth for art direction. */
export const MEDIA = {
  heroCommunity: 'photo-1469571486292-0ba58a3f068b',
  handsTogether: 'photo-1521791136064-7986c2920216',
  growth: 'photo-1518398046578-8cca57782e17',
  classroom: 'photo-1524178232363-1fb2b075b655',
  volunteers: 'photo-1559027615-cd4628902d4a',
  planning: 'photo-1454165804606-c3d57bc86b40',
  medical: 'photo-1542601906990-b4d3fb778b09',
  field: 'photo-1488646953014-85cb44e25828',
  landscape: 'photo-1469474968028-56623f02e42e',
  children: 'photo-1531206715517-5c0ba140b2b8',
  water: 'photo-1576765608535-5f04d1e3f289',
  market: 'photo-1517022812141-23620dba5c23',
  ledger: 'photo-1554224155-8d04cb21cd6c',
  community2: 'photo-1488521787991-ed7bbaae773c',
  hopeHands: 'photo-1593113598332-cd288d649433',
};

export default MEDIA;
